<template>
    <div class="columns">
        <div class="column is-12-mobile is-12-desktop is-12-widescreen">
            <div class="level">
                <div class="level-left">
                    <div class="title is-marginless is-paddingless">Profile Management
                        <span v-if="is_loading || fetching_data"
                              class="button is-white has-text-right preloader"
                              :class="{'is-loading': (is_loading || fetching_data)}"></span>
                    </div>
                </div>
            </div>

            <div class="columns">
              <div class="column is-12-mobile is-8-desktop is-8-widescreen is-paddingless is-marginless">
                    <search v-on:search="search($event)" :add-margin-left="searchMarginLeft"
                            class="is-12-desktop column is-paddingless is-marginless"
                            placeholder="Search by business or Business ID"
                    ></search>
                </div>

            </div>

            <p v-if="!fetching_data" class="margin-top-30" v-resultsCount="[total_records, all_records]"></p>

            <div class="level" v-if="!is_loading">
                <table class="table is-size-7-touch is-marginless is-fullwidth">
                    <thead>
                    <tr>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">ID</td>
                        <td class="pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey">Business</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Status</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Package</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Users</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Reviews</td>
                        <td class="is-narrow-mobile review-title is-size-7-desktop has-text-weight-bold has-text-grey">Action</td>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-if="(is_loading && items.length === 0) || (!fetching_data && items.length === 0)">
                            <td class="is-narrow pad70-desktop is-size-7-mobile is-size-7-desktop has-text-weight-bold has-text-grey" colspan="8">
                                <p class="has-text-centered is-padded-20">No results found</p>
                            </td>
                        </tr>
                        <tr class="margin-bottom-20" v-for="(item, index) in items"  v-if="items.length > 0">
                            <td class="is-narrow-mobile is-desktop break-all is-size-7-touch">{{item.id}}</td>
                            <td class="is-narrow-mobile is-desktop break-all is-size-7-touch has-text-weight-bold">{{ asText(item.org_name, 80) }}</td>
                          <td class="is-narrow-mobile is-desktop break-all is-size-7-touch">{{item.org_status}}</td>
                          <td class="is-narrow-mobile is-desktop break-all">{{item.subscription_name}}</td>
                          <td class="is-narrow-mobile is-desktop break-all">{{item.bizUserCount}}</td>
                          <td class="is-narrow-mobile is-desktop break-all">{{item.reviewCount}}</td>
                          <td class="is-narrow-mobile is-desktop break-all">
                            <a v-if="!rowIdArray.includes(item.id)" @click="addToList(item)" v-show="isShowing">Add to list</a>
                          </td>

                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="level">
                <paginator :dataSet="dataSet" @changed="getBusinessListings"></paginator>
            </div>

            <div class="level">
              <h4>Business to be merged</h4>
            </div>

          <div class="columns is-multiline merge-biz-row column  is-paddingless is-marginless">

            <div class="column is-full-tablet is-6-desktop biz-col">
              <p class="has-text-weight-bold">Primary Business</p>
              <div class="biz">
                <p v-if="primaryBiz === null">No business selected</p>
                <p v-else style="text-align: left ;padding-left:15px">{{primaryBiz.id}} &nbsp;&nbsp; {{primaryBiz.org_name}}</p>
              </div>
            </div>

            <div class="column is-full-tablet is-6-desktop biz-col">
              <p class="has-text-weight-bold">Other</p>
              <div class="biz">
                <p v-if="secondaryBiz === null">No business selected</p>
                <p v-else style="text-align: left ;padding-left:15px">{{secondaryBiz.id}} &nbsp;&nbsp; {{secondaryBiz.org_name}}</p>
              </div>
            </div>

          </div>
          <div class="columns is-multiline merge-biz-row">

            <div class="column is-full-tablet is-6-desktop biz-col">

            </div>

            <div class="column is-full-tablet is-6-desktop biz-col">
              <div class="column is-4-mobile is-6-desktop is-6-widescreen buttons is-pulled-right">
                <button @click="clearMergeView()" type="button" class="button is-button-grey is-button-small">CLEAR</button>
                <button @click="mergeBusinessesModal()"  v-bind:disabled="btnDisable" type="button" class="button is-button-grey-outline is-button-large" >MERGE</button>
              </div>
            </div>

          </div>

        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'
  import Paginator from './../../components/Paginator.vue'
  import misc from '../../mixins/misc.js'
  import qs from 'qs'
  import Search from '../../components/Search.vue'

  export default {
    metaInfo: {
      title: 'Business Portal | Hellopeter - Profile Management'
    },
    mounted () {
      this.$gtm.trackEvent({
        event: 'pageLoad',
        virtualPageUrl: this.$router.currentRoute.path,
        virtualPageTitle: 'Profile Management'
      })
      localStorage.setItem('profile-management', true)
    },
    components: {Paginator, Search},
    mixins: [misc],
    data () {
      return {
        searchMarginLeft: false,
        no_of_items: 0,
        is_loading: false,
        fetching_data: false,
        items: [],
        dataSet: {},
        page: undefined,
        total_records: 0,
        checked_items: [],
        allChecked: false,
        deleteReason: '',
        deleteReviewStatus: false,
        notifyCheck: false,
        notifyReviewer: false,
        notifyBusiness: false,
        deleteReviewerReason: '',
        deleteBizReason: '',
        reasonRevRequiredMessage: '',
        reasonBizRequiredMessage: '',
        all_records: -1,
        rowIdArray: [],
        isShowing: true,
        btnDisable: true,
        primaryBiz: null,
        secondaryBiz: null,
        mergeInProgress: false
      }
    },
    created () {
      window.events.$on('mergeBusinessAjax', this.mergeBusinessAjax)
      if (this.$route.query.keyword) {
          this.keyword_search = qs.stringify({keyword: this.$route.query.keyword})
          this.keyword_string = this.$route.query.keyword
      }
    },
    methods: {
      /**
       * Search keyword/term to search for
       * @param {string} search search term/keyword
       * @returns {void}
       */
      search (search) {
        this.keyword_search = qs.stringify({keyword: search})
        this.keyword_string = search
        this.getBusinessListings(1)
      },
      /**
       * Make request to api to get reported reviews listings
       * @returns {number | null}
       * @param {number} page page number to paginate to
       */
      getBusinessListings (page) {
        this.page = page || 1
        this.fetching_data = true
        axios.get(this.url(page, this.keyword_search))
            .then((response) => {
              this.refresh(response)
              response.data.data = undefined
              this.is_loading = false
              this.fetching_data = false
              this.allChecked = false
            })
            .catch(() => {
              flash('You are not authorized to view this resource.', 'is-danger')
              this.is_loading = false
              this.fetching_data = false
            })
      },
      /**
       * Compute URI to make call to api with.
       * @param {string} page starting page to request
       * @param {string} keyword search keyword
       * @return {string}
       */
      url (page, keyword) {
        let query = location.search.match(/page=(\d+)/)
        if (!page) {
          page = query ? query[1] : 1
        }
        if (keyword !== undefined && this.keyword_string !== 0) {
          page += `&${keyword}`
        }
        return `/businesses-profile-managment/?page=${page}&type=profileManagemnt`
      },
      clearMergeView () {
        this.primaryBiz = null
        this.secondaryBiz = null
        this.rowIdArray = []
        this.isShowing = true
        this.btnDisable = true
        this.mergeInProgress = false
        this.fetching_data = false
      },
      /**
       * Add business to list
       * @param {Object} biz Busines Object
       * @returns {null}
       */
      addToList (biz) {
          this.rowIdArray.push(biz.id)
          if (this.rowIdArray.length >= 2) {
              this.isShowing = false
              this.btnDisable = false
          }
          if (this.primaryBiz === null) {
            this.primaryBiz = biz
        } else {
            this.secondaryBiz = biz
        }
      },
      mergeBusinessesModal () {
          let options = {
              'title': 'Confirm merge',
              'body': '',
              'btn_action_title': 'MERGE NOW',
              'show_btns': true,
              'task': 'mergeBusinessAjax',
              'producer': {},
              'primaryBiz': this.primaryBiz,
              'secondaryBiz': this.secondaryBiz,
               mergeBizProfile: {
                  primaryBizName: this.primaryBiz.org_name,
                  secondaryBizName: this.secondaryBiz.org_name,
                  reviewCount: this.secondaryBiz.reviewCount,
                  userCount: this.secondaryBiz.bizUserCount
              }
          }
          modal(options)
      },
      mergeBusinessAjax (props) {
        if (props.primaryBiz !== null && props.secondaryBiz !== null && this.mergeInProgress === false) {
            this.fetching_data = true
            this.btnDisable = true
            this.mergeInProgress = true
            return axios.patch('/business/merge-profiles', {
                primary_biz: props.primaryBiz.id,
                secondary_biz: props.secondaryBiz.id
            }).then(({data}) => {
              flash(`Business has been successfully merged.`, 'is-success')
              this.clearMergeView()
            }).catch((err) => {
              if (err.response.status !== 427) {
                  this.clearMergeView()
              }
            })
        }
      }
    }
  }
</script>

<style scoped>
    .table td, .table th {
        border: none;
    }

    .table > tbody > tr {
        background-color: #f5f5f5 !important;
        margin-bottom: 10px;
    }

    .table > tbody > td {
        margin-bottom: 20px;
    }
    tr {
        cursor: pointer;
    }
    .modal-card-foot > button{
        float: right;
    }
    .headnewcl p{
        text-align:left;    display: block;
        width: 100%;
    }
    .delete-review button{
        margin-top:10px;
        padding: 4px;
        border-radius: 5px;
    }
    textarea {
        font-size: .85em !important;
    }
    .break-all {
        word-break: break-all;
    }
    .merge-biz-row .biz-col .biz
    {
      text-align: center;
      border: 1px solid #58595B;
      padding: 15px 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/profile-management/MergeBusinessProfiles.vue